/**
 * Lookup des utilisateurs pour les sélecteurs (Responsable).
 * Endpoint `/api/users` — accessible à tout utilisateur authentifié,
 * distinct de `/api/admin/users` réservé aux admins.
 */

import api from "./axiosConfig";

/**
 * Récupère la liste des utilisateurs (triés alphabétiquement par le backend).
 * @returns {Promise<Array>} Liste des utilisateurs.
 */
export async function getUsers() {
  const response = await api.get("/users");
  return response.data;
}
